// libraries
import React from "react";

// styles
import styles from "./styles.module.scss";

const Feedback = ({ toggleFeedback }) => {
  return (
    <span className={styles.feedback} onClick={toggleFeedback}>
      Feedback
    </span>
  );
};

export default Feedback;
